export const consentPropertiesTour = {
    module: 'consent_properties',
    title: 'Consent Properties Tour',
    title_vi: 'Tour Thuộc tính đồng thuận',
    description: 'As the Enterprise DPO (P-VN-01), configure CMP deployment: digital property registration, golden templates for consistent PDPL consent banners, and binding matrices that link properties to processing activities.',
    description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO (P-VN-01), configure CMP deployment: digital property registration, golden templates for consistent PDPL consent banners, and binding matrices that link properties to processing activities.',",
    estimated_duration_seconds: 32,
    steps: [
        {
            step_id: 'cp_dashboard',
            navigate_to: '/admin/consent-properties/dashboard',
            target: '.dm-page',
            title: 'Consent Properties Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Consent Properties Dashboard',
            description: 'Unlike the Consent module (which defines policies and purposes), this module configures HOW consent is deployed across your digital properties. Track adoption rates, binding coverage, and golden template usage.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Unlike the Consent module (which defines policies and purposes), this module configures HOW consent is deployed across your digital properties. Track adoption rates, binding coverage, and golden template usage.',
            position: 'bottom',
        },
        {
            step_id: 'cp_properties',
            navigate_to: '/admin/consent-properties/properties',
            target: '.dm-page',
            title: 'Property Registry',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Property Registry',
            description: 'Each property represents a digital touchpoint (website, app, kiosk) where consent is collected. As the DPO, you ensure every property has PDPL-compliant consent configurations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each property represents a digital touchpoint (website, app, kiosk) where consent is collected. As the DPO, you ensure every property has PDPL-compliant consent configurations.',
            position: 'bottom',
        },
        {
            step_id: 'cp_filters',
            target: '.dm-filters',
            title: 'Filter Properties',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Properties',
            description: 'Filter by type, group, or binding status to identify properties missing consent configurations or with unbound processing activities.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by type, group, or binding status to identify properties missing consent configurations or with unbound processing activities.',
            position: 'bottom',
        },
        {
            step_id: 'cp_create_property',
            target: '.dm-header .btn-primary',
            title: 'Add a Property',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Property',
            description: 'Register each digital property where personal data is collected. Unregistered properties represent PDPL consent compliance gaps.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register each digital property where personal data is collected. Unregistered properties represent PDPL consent compliance gaps.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'cp_create_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'New Property Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: New Property Form',
            description: 'Configure the property with its legal basis and default opt-in/opt-out behavior. PDPL requires opt-in by default for sensitive personal data categories.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure the property with its legal basis and default opt-in/opt-out behavior. PDPL requires opt-in by default for sensitive personal data categories.',
            position: 'bottom',
        },
        {
            step_id: 'cp_submit_property',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Property',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Property',
            description: 'Register the property. It can then be linked to consent purposes via bindings and deployed using golden templates for consistent PDPL compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register the property. It can then be linked to consent purposes via bindings and deployed using golden templates for consistent PDPL compliance.',
            position: 'top',
        },
        {
            step_id: 'cp_groups',
            navigate_to: '/admin/consent-properties/groups',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Property Groups',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Property Groups',
            description: 'Group related properties (e.g., all Vietnamese-market websites) for consistent consent configuration and batch deployment of PDPL-compliant banners.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Group related properties (e.g., all Vietnamese-market websites) for consistent consent configuration and batch deployment of PDPL-compliant banners.',
        },
        {
            step_id: 'cp_create_group',
            target: '.dm-header .btn-primary',
            title: 'Add a Group',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Group',
            description: 'Create a group to manage consent settings across multiple properties in a single operation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a group to manage consent settings across multiple properties in a single operation.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'cp_group_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'New Group Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: New Group Form',
            description: 'Define the group name, type, and scope. Groups ensure that all properties within a jurisdiction share the same PDPL consent configuration.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the group name, type, and scope. Groups ensure that all properties within a jurisdiction share the same PDPL consent configuration.',
            position: 'bottom',
        },
        {
            step_id: 'cp_submit_group',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Group',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Group',
            description: 'Save the group. Assign properties to it for centralized consent governance and consistent regulatory compliance across touchpoints.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the group. Assign properties to it for centralized consent governance and consistent regulatory compliance across touchpoints.',
            position: 'top',
        },
        {
            step_id: 'cp_bindings',
            navigate_to: '/admin/consent-properties/bindings',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Binding Matrix',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Binding Matrix',
            description: 'Bindings connect properties to processing activities defined in the Consent module. Unbound properties collect consent without linking it to ROPA entries, creating traceability gaps.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Bindings connect properties to processing activities defined in the Consent module. Unbound properties collect consent without linking it to ROPA entries, creating traceability gaps.',
            position: 'bottom',
        },
        {
            step_id: 'cp_golden_templates',
            navigate_to: '/admin/consent-properties/golden-templates',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Golden Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Golden Templates',
            description: 'Golden templates are DPO-approved consent configurations that enforce consistent PDPL compliance across all properties. Deploy a template to guarantee uniform banner text, opt-in defaults, and withdrawal mechanisms.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Golden templates are DPO-approved consent configurations that enforce consistent PDPL compliance across all properties. Deploy a template to guarantee uniform banner text, opt-in defaults, and withdrawal mechanisms.',
            position: 'bottom',
        },
        {
            step_id: 'cp_comparison',
            navigate_to: '/admin/consent-properties/comparison',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Comparison Workspace',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Comparison Workspace',
            description: 'Compare two consent configurations side by side before deployment. Identifies deviations from golden templates that could create inconsistent PDPL consent experiences.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Compare two consent configurations side by side before deployment. Identifies deviations from golden templates that could create inconsistent PDPL consent experiences.',
            position: 'bottom',
        },
        {
            step_id: 'cp_complete',
            target: '.dm-page',
            title: 'Consent Properties Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Consent Properties Tour Complete',
            description: 'You can now configure CMP deployment across all digital properties: registration, grouping, binding to processing activities, golden template enforcement, and configuration comparison for consistent PDPL compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now configure CMP deployment across all digital properties: registration, grouping, binding to processing activities, golden template enforcement, and configuration comparison for consistent PDPL compliance.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=consent-properties.js.map